import React, { useEffect, useState } from 'react';
import './Order.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config/firebase'; 
import { secureFetch } from '../../utils/secureFetch';

const statusLabels = {
  pending: 'Pendiente',
  processing: 'Procesando',
  shipped: 'Enviado',
  delivered: 'Entregado',
  canceled: 'Cancelado',
};

const API_BASE_URL = 'https://api.minymol.com';

const Order = ({ id, status, total, cantidad, images }) => {
  const navigate = useNavigate();
  const location = useLocation(); // ⬅️ para detectar desde dónde llaman el componente
  const [nombreMostrar, setNombreMostrar] = useState('Cargando...');
  const [fechaHora, setFechaHora] = useState({ fecha: '', hora: '' });
  const [ordenNumProveedor, setOrdenNumProveedor] = useState('');

  useEffect(() => {
    const fetchDatosOrden = async () => {
      try {
        const res = await secureFetch(`${API_BASE_URL}/orders/${id}`);

        if (!res.ok) throw new Error('Error al obtener la orden');
        const data = await res.json();

        const nombreCliente = data?.customer?.nombre;
        const nombreProveedor = data?.provider?.nombre_empresa;
        setOrdenNumProveedor(data?.providerOrderNumber || '—');

        // Ruta actual
        const ruta = location.pathname;

        if (ruta.includes('/my-orders') && nombreCliente) {
          setNombreMostrar(`Cliente: ${nombreCliente}`);
        } else if (ruta.includes('/mis-pedidos') && nombreProveedor) {
          setNombreMostrar(`Proveedor: ${nombreProveedor}`);
        } else {
          setNombreMostrar('Desconocido');
        }

        const fechaActualizada = new Date(data.updatedAt);
        setFechaHora({
          fecha: fechaActualizada.toLocaleDateString('es-CO', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          }),
          hora: fechaActualizada.toLocaleTimeString('es-CO', {
            hour: '2-digit',
            minute: '2-digit'
          }),
        });
      } catch (error) {
        console.error(error);
        setNombreMostrar('Desconocido');
      }
    };

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        fetchDatosOrden();
      }
    });

    return () => unsubscribe();
  }, [id, location.pathname]);

  return (
    <div className="order-card" onClick={() => navigate(`/orden/${id}`)}>
      <div className="order-header">
        <div className='order-time'>
          <p className='order-date'>{fechaHora.fecha}</p>
          <p className='order-hour'>{fechaHora.hora}</p>
        </div>
        <span className={`order-status ${status}`}>{statusLabels[status] || status}</span>
      </div>

      <h3 className='order-num'>Pedido #{ordenNumProveedor}</h3>

      <p className='order-client'>{nombreMostrar}</p>

      <div className='order-items'>
        <div className="order-images-wrapper">
          <div className="order-images">
            {images.map((img, index) => (
              <img key={index} src={img} alt={`Producto ${index + 1}`} />
            ))}
          </div>
        </div>

        <div className="order-quantity">
          <p>COP {(Math.floor(Number(total) / 100) * 100).toLocaleString('es-CO') || '—'}</p>
          <p>{cantidad} productos</p>
        </div>
        <button className="order-button">
          <FontAwesomeIcon icon={faChevronRight} className="order-icon" />
        </button>
      </div>
    </div>
  );
};

export default Order;
